function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import { LG, MS } from "constants/sizes";
import { CONTACT_SALES_HUBSPOT_FORM_ID } from "client/services/hubspot-service/contact-form-config";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { StyledHubspotOnDarkBackgroundFormComponent } from "./hubspot-on-dark-background-form-component.scss";
import { VI_ICON } from "./consts";
import PictureComponent from "/components/core/picture/picture-component";
const HubspotOnDarkBackgroundFormComponent = (props)=>{
    const { LeftSideContent, formId } = props;
    const { title, textUnderSeparator, valuesList, sentenceAboveLogos, customerQuote, logos } = LeftSideContent || {};
    const { quote, name, jobDescription, companyName, facePicture } = customerQuote || {};
    const renderLeftSide = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "content",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "top-part",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "title-section",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "title-wrapper",
                                    children: /*#__PURE__*/ _jsx(Title, {
                                        title: title,
                                        titleSize: LG
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "values-list-wrapper",
                                    children: valuesList === null || valuesList === void 0 ? void 0 : valuesList.map((valueItem, index)=>/*#__PURE__*/ _jsxs("div", {
                                            className: "value-item",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "vi-icon",
                                                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                        src: VI_ICON
                                                    })
                                                }),
                                                valueItem.value
                                            ]
                                        }, index))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "seperator-line"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-under-separator",
                            children: /*#__PURE__*/ _jsx(Paragraph, {
                                body: textUnderSeparator,
                                textSize: MS
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "bottom-part",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "customer-quote-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("blockquote", {
                                    className: "quote",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "quoteText",
                                        children: `”${quote}”`
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "costumer-details",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "face-picture",
                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                src: facePicture
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "name-and-job-description",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "name",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "job-description",
                                                    children: `${jobDescription} | ${companyName}`
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "logos-wrapper",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "logos",
                                children: logos === null || logos === void 0 ? void 0 : logos.map((logo, index)=>/*#__PURE__*/ _jsx("div", {
                                        className: "logo-wrapper",
                                        children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, logo))
                                    }, index))
                            })
                        })
                    ]
                })
            ]
        });
    };
    const getFormId = ()=>{
        return formId || CONTACT_SALES_HUBSPOT_FORM_ID;
    };
    const renderForm = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "form-wrapper",
            children: /*#__PURE__*/ _jsx(HubspotContactForm, _object_spread({
                isV2: true,
                formId: getFormId()
            }, props))
        });
    };
    return /*#__PURE__*/ _jsx(StyledHubspotOnDarkBackgroundFormComponent, {
        className: "hubspot-on-dark-background-form-component",
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, {
            replaceTextComponent: renderLeftSide,
            replaceAssetComponent: renderForm,
            mobileSwapTextAndAssetPosition: true
        })
    });
};
export default /*#__PURE__*/ memo(HubspotOnDarkBackgroundFormComponent);
